<template>
  <div>
    <div v-for="(element,index) in hostList" :key="index">
      <div style="margin-bottom:1rem;" v-if="element.offlineList.length > 0">
        <div style="padding-bottom:0.35rem;">
          <span v-if="hostList.length < 2" class="us_block_title">异常的设备</span>
          <span v-else class="us_block_title">异常的设备 - {{ element.dev_text }}</span>
          <span class="us_block_more_text" @click="goList(1)">
            <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <LoadingText v-if="loading" />
        <div v-else v-for="(item,index) in element.offlineList" :key=" 'off' + index " style="background:#fff;" >
          <DeviceCard :dev-info="item" :dev-prop="item.prop" :idx=" index + 1 " flat />
        </div>
      </div>
      <div style="padding-bottom:0.35rem;">
        <span v-if="hostList.length < 2" class="us_block_title">关注的设备</span>
        <span v-else class="us_block_title">关注的设备 - {{ element.dev_text }}</span>
        <span class="us_block_more_text" @click="goList(2)">
          <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
      </div>
      <LoadingText v-if="loading" />
      <div v-else v-for="(item,index) in element.list" :key="'on'+index" style="background:#fff;" >
        <DeviceCard :dev-info="item" :dev-prop="item.prop" :idx=" index + 1 " flat />
      </div>
      <div v-if="element.list.length === 0 && !loading" style="text-align:center;background:#fff;padding:1rem 0;">
        <!-- <div><img src="/res/no_record.jpg" alt="no_record"></div> -->
        <div style="font-size:0.8rem;color:#9e9e9e;">暂无正常设备</div>
      </div>
      <div style="margin:1rem 0;"></div>
    </div>
  </div>
</template>

<script>
import DeviceCard from '../../Biz/Device/DeviceCard'
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    DeviceCard,
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      // 异常设备列表
      offlineList: [],
      hostList: [],
      // hostList: [
      //   {
      //     gw_iot_id: '',
      //     dev_text: '',
      //     list: [],
      //     offlineList: []
      //   }
      // ],
      loading: true,
      timeout: null
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getListTask()
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
    this.getListTask();
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    goList(state) {
      this.$router.goPage({ path: '/DeviceList', query: { state: state }})
    },
    async getList() {
      var that = this
      await that.$api.iot.queryDeviceList({ state: -1 }).then(res => {
        console.log('queryDeviceList', res);
        if (!res.success) {
          that.loading = false
          console.log('获取设备列表失败', res);
          // that.$toast.error('获取设备列表失败')
          return
        }
        var data = res.data
        that.hostList = []
        for (let index = 0; index < data.length; index++) {
          const item = data[index];
          let gateway_iot_id = item.GATEWAY_IOT_ID
          const iot_id = item.IOT_ID
          let dev_text = ''

          if (item.PROD_TYPE == 'gateway') {
            dev_text = item.DEV_TEXT
          }

          if (!gateway_iot_id) {
            gateway_iot_id = iot_id
          }

          var hostData = that.hostList.filter((i) => {
            return gateway_iot_id == i.gw_iot_id;
          });

          if (hostData && hostData.length > 0) {
            if (item.PROD_TYPE == 'gateway') {
              hostData[0].dev_text = item.DEV_TEXT
            }

            if (item.CUR_SID === 2 || item.CUR_SID === '2') {
              hostData[0].list.push(item)
            } else {
              hostData[0].offlineList.push(item)
            }
          } else {
            const hostDev = {
              gw_iot_id: gateway_iot_id,
              dev_text: dev_text,
              list: [],
              offlineList: []
            }

            if (item.CUR_SID === 2 || item.CUR_SID === '2') {
              hostDev.list.push(item)
            } else {
              hostDev.offlineList.push(item)
            }

            that.hostList.push(hostDev)
          }
        }

        console.log(that.hostList)
        // that.list = []
        // that.offlineList = []
        // for (let index = 0; index < data.length; index++) {
        //   var item = data[index];
        //   // item.prop.ping_state === 'online'
        //   if (item.CUR_SID === 2 || item.CUR_SID === '2') {
        //     that.list.push(item)
        //   } else {
        //     that.offlineList.push(item)
        //   }
        // }
        that.loading = false
      })
    },
    async getListTask() {
      var that = this;
      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }
      await that.getList();
      that.timeout = setTimeout(that.getListTask, 30 * 1000);
    }
  }
}
</script>

<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
  cursor: pointer;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}
</style>
